<template>
  <div class="recent-post-section">
    <slick
      ref="postSlider1"
      :options="postSlider1"
      class="post-slider green-slick-dots arrow-slider px-lg-5"
    >
      <div v-for="(data, index) in recentPostsData" :key="index">
        <div class="post-card" @click="$router.push({ path: data.link })">
          <div class="post-img">
            <img
              :src="require('@/assets/imgs/posts/' + data.img)"
              class="img-fluid"
            />
          </div>
          <div class="post-content pt-1">
            <h5 class="title">{{ data.title }}</h5>
            <p class="date">{{ data.date }}</p>
            <div class="text pt-1">
              Are you planning to study abroad, but are not sure where to start
              exploring your options? The answer is simple, start with meeting a
              foreign education consultant.
            </div>
            <div class="pt-2 text-center anchor-text-black">
              Read article &rarr;
            </div>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
export default {
  name: "BlogSlickSlider",
  components: {},
  data() {
    return {
      postSlider1: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: this.slidesShow,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  props: {
    recentPostsData: {
      type: Array,
      default: "",
    },
     slidesShow: {
      type: Number,
      default: 2,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/Blogs/BlogSlickSlider.vue